import { GetUserLedgerTypesResponse } from "@syla/shared/types/responses/GetUserLedgerTypesResponse";
import axios from "axios";

import { TransportType } from "@syla/shared/types/helpers/TransportType";

export const getUserLedgerTypes = async (): Promise<
  TransportType<GetUserLedgerTypesResponse>
> => {
  const { data } = await axios.get("/transactions/ledger-types");
  return data;
};
